// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"160":"ea615740","275":"138b098f","861":"a8c3508c","896":"7ed70f10"}[chunkId] + ".css";
};